import React from 'react';
import { Box } from '@mui/material';
import { FormikAutoSave, TIME_RANGE_DATE_VALUE_FORMAT, TimePicker, getStartAndEndTimeInput } from '@uplift/ui-v2';
import { patchSessionPsychiatryNote } from '@uplift/api';
import { useSessionPsychiatryNoteQuery } from '@uplift/queries';
import { Formik } from 'formik';
import { CalendarDateService } from '@uplift/services';
import { useTimezone } from '@uplift/contexts';


export const SessionTimeSection: React.VFC<{ sessionId: string }> = ({ sessionId }) => {
  const timezone = useTimezone();
  const { data } = useSessionPsychiatryNoteQuery(sessionId, { refetchOnMount: true, keepPreviousData: false });

  return (
    <Formik
      enableReinitialize
      initialValues={{
        startTime: CalendarDateService.date(data?.startTime).tz(timezone).format(TIME_RANGE_DATE_VALUE_FORMAT),
      }}
      onSubmit={async values => {
        if (!data?.startTime) return;

        const range = getStartAndEndTimeInput(data.startTime, timezone, values.startTime, values.startTime);

        await patchSessionPsychiatryNote(sessionId, {
          start_time: range.startTime,
        });
      }}
    >
      <Box px={3} py={2} maxWidth="100px">
        <TimePicker
          label="Start time"
          name="startTime"
          searchSelect
          minuteIncrement={5}
        />

        <FormikAutoSave />
      </Box>
    </Formik>
  );
};
